import {useState} from 'react'
import {Flex, Image} from '@chakra-ui/react'
import Logo from '@assets/svgs/logo.svg'
import {CommonColors} from '@utils/CommonStyles'
import {useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import Otp from '@pages/NonAuthentication/RegisterPage/components/Otp'
import SignUp from '@pages/NonAuthentication/RegisterPage/components/SignUp'
import VerifyPassword from './components/VerifyPassword'
import Loading from '@components/Loading'
import bgLogin from '@assets/images/bg-login.png'

const RegisterPage = () => {
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const [isSignUp, setIsSignUp] = useState(true)
  const [isVerifyPassword, setIsVerifyPassword] = useState(false)
  const [user, setUser] = useState(null)

  const handleGoHome = () => {
    navigate(PATH.HOME)
  }

  return (
    <Flex
      sx={styles.container}
      bgImage={bgLogin}
      bgSize={'cover'}
      bgPosition={'center'}
      bgRepeat={'no-repeat'}
      px={{base: 4, md: 0}}>
      {isLoading && <Loading />}
      <Image
        w={{base: '300px', md: '400px'}}
        cursor={'pointer'}
        onClick={handleGoHome}
        src={Logo}
        sx={styles.logo}
      />
      {isSignUp ? (
        isVerifyPassword ? (
          <VerifyPassword user={user} />
        ) : (
          <SignUp
            setIsLoading={setIsLoading}
            onSubmit={(data: any) => {
              setUser(data)
              setIsSignUp(false)
            }}
          />
        )
      ) : (
        <Otp
          user={user}
          setUser={setUser}
          setIsVerifyPassword={setIsVerifyPassword}
          setIsSignUp={setIsSignUp}
          handleBack={() => {
            setIsSignUp(true)
          }}
        />
      )}
    </Flex>
  )
}

const styles = {
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    flexDirection: 'column',
    backgroundColor: CommonColors.blue1,
  },
  logo: {
    marginBottom: '48px',
  },
}

export default RegisterPage
